import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

export default function Alertas({
  title,
  html,
  icono,
  clasePropia,
  textButton = "Aceptar",
}) {
  return Swal.fire({
    title,
    html,
    icon: icono,
    customClass: {
      confirmButton:
        "boton-alerta-componente btn-geomedellin btn-register-admin btn-accion btn btn-primary",
    },
    confirmButtonText: textButton,
  });
}
